import type { CategoryGroup } from "@/types/video";

export const categoryGroups: CategoryGroup[] = [
  {
    type: "movie",
    name: "电影",
    slug: "movie",
    tagline: "两小时的光影远行",
    description:
      "从爆裂动作到细腻剧情，从浩瀚科幻到烧脑悬疑，精选院线热片与口碑佳作，按类型与年份快速找到今晚想看的那一部。",
    icon: "ri-film-line",
    subcategories: [
      { id: "movie-action", name: "动作", type: "movie", description: "追车、爆破与硬核对决，肾上腺素持续拉满的动作佳作。" },
      { id: "movie-drama", name: "剧情", type: "movie", description: "聚焦真实人生与情感纹理，后劲很足的叙事电影。" },
      { id: "movie-scifi", name: "科幻", type: "movie", description: "深空、未来与人工智能，想象力构筑的宏大世界。" },
      { id: "movie-thriller", name: "悬疑", type: "movie", description: "层层反转与心理博弈，看到最后一秒才懂真相。" },
      { id: "movie-comedy", name: "喜剧", type: "movie", description: "轻松解压的欢乐时刻，适合全家一起看的笑点密集片。" },
      { id: "movie-romance", name: "爱情", type: "movie", description: "心动、错过与重逢，把温柔留在银幕上的爱情故事。" },
    ],
  },
  {
    type: "series",
    name: "电视剧",
    slug: "series",
    tagline: "一集接一集停不下来",
    description:
      "都市情感、古装传奇、家庭群像与悬疑追凶，覆盖热门连载与完结好剧，支持按地区、年份与评分筛选，追剧更顺手。",
    icon: "ri-tv-2-line",
    subcategories: [
      { id: "series-urban", name: "都市", type: "series", description: "写字楼与烟火气之间，属于当代人的情感与选择。" },
      { id: "series-costume", name: "古装", type: "series", description: "朝代风云、江湖恩怨与家国情怀的古装长篇。" },
      { id: "series-suspense", name: "悬疑", type: "series", description: "案件背后的人性拼图，一集一个钩子，越看越上头。" },
      { id: "series-family", name: "家庭", type: "series", description: "三代同堂的琐碎与温情，平凡生活里的治愈力量。" },
    ],
  },
  {
    type: "short",
    name: "短视频",
    slug: "short",
    tagline: "几分钟收获好心情",
    description:
      "搞笑段子、美食探店、旅行见闻、生活记录与音乐现场，短小但有料的内容池，随时打开随时放松。",
    icon: "ri-smartphone-line",
    subcategories: [
      { id: "short-funny", name: "搞笑", type: "short", description: "办公室、地铁与日常里的荒诞瞬间，笑点三秒一个。" },
      { id: "short-food", name: "美食", type: "short", description: "深夜食堂、街角烘焙与家常烟火，看得见的香气。" },
      { id: "short-travel", name: "旅行", type: "short", description: "山野、海岸与城市漫步，用几分钟看一处风景。" },
      { id: "short-life", name: "生活", type: "short", description: "阳台、搬家与四季小事，认真生活的温柔记录。" },
      { id: "short-music", name: "音乐", type: "short", description: "天台、Livehouse 与街头旋律，耳朵先放松下来。" },
    ],
  },
];

export const getCategoryGroup = (type: string): CategoryGroup | undefined =>
  categoryGroups.find((group) => group.type === type || group.slug === type);

export const getAllSubCategories = () => categoryGroups.flatMap((group) => group.subcategories);

export const getSubCategory = (id: string) => getAllSubCategories().find((item) => item.id === id);